module.exports = __webpack_public_path__ + "assets/upload_photo.svg?v=2a8859c578045ae37d888677da807fda";